module.exports = __webpack_public_path__ + "static/img/ttt-cn.f756dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/ttt-cn.png
// module id = hAWO
// module chunks = 1